const VERSION: string = '0.1.7-prod.108'
export default VERSION;
